import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//Jake: Please do not update the react-dom render. This project is not compatible with React 18 and so updating this will cause issues in App.tsx
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
